import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useStockMovementData from "@/hooks/data/use-stock-movement-data";
import { IStockMovement } from "@/interfaces/sku-movement.interfaces";
import { SkuMovementMessages } from "@/messages/sku/sku-movement.messages";

interface StockMovementTableRowProps {
  movement: IStockMovement;
  index: number;
  messages: SkuMovementMessages;
}

export function StockMovementTableRow({ movement, index, messages }: StockMovementTableRowProps) {
  const { formattedType, formattedQuantity, comments, formattedMovementDate } =
    useStockMovementData({
      movement,
      messages,
    });

  return (
    <TableRow index={index}>
      <TableCell>{formattedMovementDate}</TableCell>
      <TableCell>{formattedType}</TableCell>
      <TableCell>{formattedQuantity}</TableCell>
      <TableCell>{comments as string}</TableCell>
    </TableRow>
  );
}
